<template>
  <Layout>
    <b-row class="m-5 mb-3">
      <b-col>
        <h1 class="mb-3" style="margin-top: 50px;">Ranking</h1>
      </b-col>
    </b-row>
    <b-row class="m-0 p-5 bg-white">
      <div style="margin:auto; width:80%; position:relative;">
        <h2 style="text-align: left;
    margin-bottom: 40px;">Modalidad {{modalidad}}</h2>

        <div style=" min-height:200px">
          <div
            v-if="loading"
            class="b-overlay position-absolute"
            style="top: 0px; left: 0px; bottom: 0px; right: 0px; z-index: 10;"
          >
            <div
              class="position-absolute bg-light rounded-sm"
              style="top: 140px; left: 0px; bottom: 80px; right: 0px; opacity: 0.85; backdrop-filter: blur(2px);"
            ></div>
            <div
              class="position-absolute"
              style="top: 50%; left: 50%; transform: translateX(-50%) translateY(-50%);"
            >
              <b-spinner label="Spinning" variant="primary"></b-spinner>
            </div>
          </div>
          <b-table outlined id="rank-table" hover :items="rankings" :per-page="0" :fields="fields"></b-table>
        </div>

        <b-pagination
          align="center"
          hide-goto-end-buttons
          v-model="currentPage"
          :total-rows="totalItems"
          :per-page="perPage"
          prev-class="previ"
          next-class="nexti"
          prev-text="anterior"
          next-text="siguiente"
          aria-controls="rank-table"
        ></b-pagination>
      </div>
    </b-row>
    <RankingBuscador id="ranking" :options="options" />
  </Layout>
</template>

<script>
/*const mockRank = [
  {
    id: 1,
    first_name: "Corliss",
    last_name: "Roston",
    club: "Lemur catta",
    ranking: 131
  },
  {
    id: 2,
    first_name: "Valentine",
    last_name: "Josefs",
    club: "Ardea golieth",
    ranking: 32
  },
  {
    id: 3,
    first_name: "Kim",
    last_name: "Andrich",
    club: "Uraeginthus granatina",
    ranking: 89
  },
  {
    id: 4,
    first_name: "Sharon",
    last_name: "Freddi",
    club: "Psittacula krameri",
    ranking: 108
  },
  {
    id: 5,
    first_name: "Faina",
    last_name: "Hockell",
    club: "Isoodon obesulus",
    ranking: 92
  },
  {
    id: 6,
    first_name: "Ferris",
    last_name: "Sevier",
    club: "Zosterops pallidus",
    ranking: 64
  },
  {
    id: 7,
    first_name: "Doe",
    last_name: "Peach",
    club: "Eumetopias jubatus",
    ranking: 107
  },
  {
    id: 8,
    first_name: "Irwin",
    last_name: "Robrow",
    club: "Pan troglodytes",
    ranking: 8
  },
  {
    id: 9,
    first_name: "Rozanne",
    last_name: "MacSherry",
    club: "Ardea golieth",
    ranking: 149
  },
  {
    id: 10,
    first_name: "Enrica",
    last_name: "Gaffney",
    club: "Aegypius tracheliotus",
    ranking: 15
  },
  {
    id: 11,
    first_name: "Gracie",
    last_name: "Scrange",
    club: "Connochaetus taurinus",
    ranking: 52
  },
  {
    id: 12,
    first_name: "Guntar",
    last_name: "Wiskar",
    club: "Trichoglossus chlorolepidotus",
    ranking: 42
  },
  {
    id: 13,
    first_name: "Delmore",
    last_name: "Raiment",
    club: "Lasiodora parahybana",
    ranking: 146
  },
  {
    id: 14,
    first_name: "Jesus",
    last_name: "Yurkin",
    club: "Uraeginthus bengalus",
    ranking: 50
  },
  {
    id: 15,
    first_name: "Rozella",
    last_name: "Hufton",
    club: "Macaca radiata",
    ranking: 12
  },
  {
    id: 16,
    first_name: "Rachel",
    last_name: "Gerkens",
    club: "Odocoilenaus virginianus",
    ranking: 6
  },
  {
    id: 17,
    first_name: "Aloysia",
    last_name: "Ortner",
    club: "Uraeginthus granatina",
    ranking: 31
  },
  {
    id: 18,
    first_name: "Giulio",
    last_name: "Shead",
    club: "Oreamnos americanus",
    ranking: 69
  },
  {
    id: 19,
    first_name: "Ingeberg",
    last_name: "Lathleiff",
    club: "Felis caracal",
    ranking: 31
  },
  {
    id: 20,
    first_name: "Quintina",
    last_name: "O' Mahony",
    club: "Aegypius tracheliotus",
    ranking: 52
  },
  {
    id: 21,
    first_name: "Gwynne",
    last_name: "Haskayne",
    club: "Vulpes chama",
    ranking: 23
  },
  {
    id: 22,
    first_name: "Ursala",
    last_name: "Strathman",
    club: "Crocuta crocuta",
    ranking: 96
  },
  {
    id: 23,
    first_name: "Graham",
    last_name: "Collet",
    club: "Caiman crocodilus",
    ranking: 137
  },
  {
    id: 24,
    first_name: "Cati",
    last_name: "Tebbutt",
    club: "Tockus flavirostris",
    ranking: 89
  },
  {
    id: 25,
    first_name: "Reynold",
    last_name: "Soame",
    club: "Anser caerulescens",
    ranking: 74
  },
  {
    id: 26,
    first_name: "Cammy",
    last_name: "Al Hirsi",
    club: "Tachyglossus aculeatus",
    ranking: 7
  },
  {
    id: 27,
    first_name: "Claudian",
    last_name: "McConnal",
    club: "Bubulcus ibis",
    ranking: 36
  },
  {
    id: 28,
    first_name: "Modestia",
    last_name: "Bullcock",
    club: "Varanus komodensis",
    ranking: 59
  },
  {
    id: 29,
    first_name: "Rosana",
    last_name: "Mungan",
    club: "Scolopax minor",
    ranking: 92
  },
  {
    id: 30,
    first_name: "Simonette",
    last_name: "Dilawey",
    club: "Galictis vittata",
    ranking: 110
  },
  {
    id: 31,
    first_name: "Gibb",
    last_name: "Elverston",
    club: "Herpestes javanicus",
    ranking: 117
  },
  {
    id: 32,
    first_name: "Orren",
    last_name: "Benzing",
    club: "Camelus dromedarius",
    ranking: 106
  },
  {
    id: 33,
    first_name: "Nat",
    last_name: "Gregson",
    club: "Drymarchon corias couperi",
    ranking: 138
  },
  {
    id: 34,
    first_name: "Rufus",
    last_name: "Pohlke",
    club: "Ara ararauna",
    ranking: 128
  },
  {
    id: 35,
    first_name: "Bailey",
    last_name: "Shackelton",
    club: "Crotalus adamanteus",
    ranking: 56
  },
  {
    id: 36,
    first_name: "Vita",
    last_name: "Trevan",
    club: "Columba palumbus",
    ranking: 68
  },
  {
    id: 37,
    first_name: "Ethan",
    last_name: "Mewitt",
    club: "Castor fiber",
    ranking: 139
  },
  {
    id: 38,
    first_name: "Hanan",
    last_name: "Mattiuzzi",
    club: "Alcelaphus buselaphus cokii",
    ranking: 73
  },
  {
    id: 39,
    first_name: "Minerva",
    last_name: "Sarsons",
    club: "Butorides striatus",
    ranking: 58
  },
  {
    id: 40,
    first_name: "Marti",
    last_name: "Clemett",
    club: "unavailable",
    ranking: 106
  },
  {
    id: 41,
    first_name: "Georgia",
    last_name: "Haggarth",
    club: "Lasiodora parahybana",
    ranking: 109
  },
  {
    id: 42,
    first_name: "Mala",
    last_name: "Dawbury",
    club: "Gekko gecko",
    ranking: 34
  },
  {
    id: 43,
    first_name: "Morton",
    last_name: "Keers",
    club: "Pelecanus conspicillatus",
    ranking: 17
  },
  {
    id: 44,
    first_name: "Erwin",
    last_name: "Maden",
    club: "Grus antigone",
    ranking: 22
  },
  {
    id: 45,
    first_name: "Cherie",
    last_name: "Piburn",
    club: "Chlamydosaurus kingii",
    ranking: 71
  },
  {
    id: 46,
    first_name: "Gerick",
    last_name: "Stannard",
    club: "Himantopus himantopus",
    ranking: 39
  },
  {
    id: 47,
    first_name: "Codie",
    last_name: "Simnor",
    club: "Alligator mississippiensis",
    ranking: 122
  },
  {
    id: 48,
    first_name: "Fannie",
    last_name: "Duckerin",
    club: "Larus dominicanus",
    ranking: 122
  },
  {
    id: 49,
    first_name: "Rocky",
    last_name: "Woodfine",
    club: "Eudyptula minor",
    ranking: 91
  },
  {
    id: 50,
    first_name: "Claiborn",
    last_name: "Pinshon",
    club: "Ara chloroptera",
    ranking: 19
  },
  {
    id: 51,
    first_name: "Hussein",
    last_name: "Kemshell",
    club: "Egretta thula",
    ranking: 132
  },
  {
    id: 52,
    first_name: "Starr",
    last_name: "Tanslie",
    club: "Papilio canadensis",
    ranking: 8
  },
  {
    id: 53,
    first_name: "Loleta",
    last_name: "Darnborough",
    club: "unavailable",
    ranking: 87
  },
  {
    id: 54,
    first_name: "Helen",
    last_name: "Sidwell",
    club: "Bugeranus caruncalatus",
    ranking: 24
  },
  {
    id: 55,
    first_name: "Drucy",
    last_name: "Leaman",
    club: "Corvus albus",
    ranking: 13
  },
  {
    id: 56,
    first_name: "Anet",
    last_name: "Lamplough",
    club: "Diceros bicornis",
    ranking: 123
  },
  {
    id: 57,
    first_name: "Garwin",
    last_name: "Berthe",
    club: "Tursiops truncatus",
    ranking: 81
  },
  {
    id: 58,
    first_name: "Logan",
    last_name: "Proud",
    club: "Lybius torquatus",
    ranking: 46
  },
  {
    id: 59,
    first_name: "Leena",
    last_name: "Stuffins",
    club: "Acinynox jubatus",
    ranking: 142
  },
  {
    id: 60,
    first_name: "Yancy",
    last_name: "Flipek",
    club: "Ninox superciliaris",
    ranking: 15
  },
  {
    id: 61,
    first_name: "Valerye",
    last_name: "Power",
    club: "Macropus fuliginosus",
    ranking: 33
  },
  {
    id: 62,
    first_name: "Sydel",
    last_name: "Mearns",
    club: "Phasianus colchicus",
    ranking: 64
  },
  {
    id: 63,
    first_name: "Warner",
    last_name: "Mix",
    club: "Colobus guerza",
    ranking: 59
  },
  {
    id: 64,
    first_name: "Tiebout",
    last_name: "Brusle",
    club: "Mellivora capensis",
    ranking: 35
  },
  {
    id: 65,
    first_name: "Brewer",
    last_name: "Wyld",
    club: "Varanus salvator",
    ranking: 1
  },
  {
    id: 66,
    first_name: "Rea",
    last_name: "Tomney",
    club: "Alopex lagopus",
    ranking: 35
  },
  {
    id: 67,
    first_name: "Nona",
    last_name: "Roux",
    club: "Phoca vitulina",
    ranking: 51
  },
  {
    id: 68,
    first_name: "Cullin",
    last_name: "Lots",
    club: "Dusicyon thous",
    ranking: 77
  },
  {
    id: 69,
    first_name: "Karil",
    last_name: "Beaten",
    club: "Ovis ammon",
    ranking: 138
  },
  {
    id: 70,
    first_name: "Marlane",
    last_name: "Gwatkin",
    club: "Uraeginthus angolensis",
    ranking: 80
  },
  {
    id: 71,
    first_name: "Loralie",
    last_name: "Ackerley",
    club: "Plegadis falcinellus",
    ranking: 118
  },
  {
    id: 72,
    first_name: "Josias",
    last_name: "Beedon",
    club: "Tamiasciurus hudsonicus",
    ranking: 118
  },
  {
    id: 73,
    first_name: "Opalina",
    last_name: "Kless",
    club: "Ovis ammon",
    ranking: 41
  },
  {
    id: 74,
    first_name: "Kalina",
    last_name: "Stangroom",
    club: "Canis lupus baileyi",
    ranking: 77
  },
  {
    id: 75,
    first_name: "Romola",
    last_name: "Wealleans",
    club: "Plocepasser mahali",
    ranking: 29
  },
  {
    id: 76,
    first_name: "Leora",
    last_name: "Duce",
    club: "Equus burchelli",
    ranking: 88
  },
  {
    id: 77,
    first_name: "Nat",
    last_name: "Angove",
    club: "Varanus salvator",
    ranking: 4
  },
  {
    id: 78,
    first_name: "Elwood",
    last_name: "Bryden",
    club: "Certotrichas paena",
    ranking: 130
  },
  {
    id: 79,
    first_name: "Thatch",
    last_name: "Signorelli",
    club: "Francolinus coqui",
    ranking: 103
  },
  {
    id: 80,
    first_name: "Deeanne",
    last_name: "Dalmon",
    club: "Mustela nigripes",
    ranking: 132
  },
  {
    id: 81,
    first_name: "Tris",
    last_name: "O' Clovan",
    club: "Anser anser",
    ranking: 60
  },
  {
    id: 82,
    first_name: "Therine",
    last_name: "Neylon",
    club: "Aegypius occipitalis",
    ranking: 101
  },
  {
    id: 83,
    first_name: "Wynny",
    last_name: "Afield",
    club: "Sula nebouxii",
    ranking: 138
  },
  {
    id: 84,
    first_name: "Griff",
    last_name: "Cursey",
    club: "Helogale undulata",
    ranking: 65
  },
  {
    id: 85,
    first_name: "Dulcinea",
    last_name: "Fritzer",
    club: "Phoca vitulina",
    ranking: 140
  },
  {
    id: 86,
    first_name: "Wit",
    last_name: "Savin",
    club: "Acrantophis madagascariensis",
    ranking: 59
  },
  {
    id: 87,
    first_name: "Aimee",
    last_name: "Coulthard",
    club: "Macropus agilis",
    ranking: 58
  },
  {
    id: 88,
    first_name: "Shoshana",
    last_name: "Scud",
    club: "Milvus migrans",
    ranking: 107
  },
  {
    id: 89,
    first_name: "Justin",
    last_name: "Foxhall",
    club: "Pseudalopex gymnocercus",
    ranking: 70
  },
  {
    id: 90,
    first_name: "Marji",
    last_name: "Peartree",
    club: "Odocoileus hemionus",
    ranking: 38
  },
  {
    id: 91,
    first_name: "Elihu",
    last_name: "Crocket",
    club: "Diomedea irrorata",
    ranking: 3
  },
  {
    id: 92,
    first_name: "Karalynn",
    last_name: "Cadden",
    club: "Grus rubicundus",
    ranking: 69
  },
  {
    id: 93,
    first_name: "Cristiano",
    last_name: "Coppo",
    club: "Turtur chalcospilos",
    ranking: 106
  },
  {
    id: 94,
    first_name: "Bryna",
    last_name: "Hartness",
    club: "Dusicyon thous",
    ranking: 125
  },
  {
    id: 95,
    first_name: "Quintus",
    last_name: "Feore",
    club: "Corythornis cristata",
    ranking: 150
  },
  {
    id: 96,
    first_name: "Corissa",
    last_name: "Maryon",
    club: "Acinynox jubatus",
    ranking: 137
  },
  {
    id: 97,
    first_name: "Sheila",
    last_name: "Perle",
    club: "Bucephala clangula",
    ranking: 27
  },
  {
    id: 98,
    first_name: "Avigdor",
    last_name: "Emmens",
    club: "Vulpes vulpes",
    ranking: 133
  },
  {
    id: 99,
    first_name: "Demetria",
    last_name: "Tarte",
    club: "Egretta thula",
    ranking: 148
  },
  {
    id: 100,
    first_name: "Burlie",
    last_name: "Doel",
    club: "Rhea americana",
    ranking: 114
  }
];*/
import RankingBuscador from "../components/RankingBuscador";
import axios from "axios";
import config from "../../public/data/config.json"
export default {
  components: {
    RankingBuscador
  },
  metaInfo: {
    title: "Ranking"
  },
  data() {
    return {
      modalidad: null,
      perPage: 20,
      currentPage: 0,
      rankings: [],
      loading: false,
      options: [],
      totalItems: 0,
      theValue: null,
      fields: [
        {
          key: "name",
          label: "Nombre"
        },
        {
          key: "club",
          label: "CLub"
        },
        {
          key: "ranking",
          label: "Ranking"
        }
      ]
    };
  },
  computed: {
    rows() {
      return this.totalItems;
    }
  },
  watch: {
    currentPage: {
      handler: function(value) {
        this.theValue = value;
        this.getRankings(this.modalidad, this.perPage, this.currentPage).catch(
          error => {
            console.error(error);
          }
        );
      }
    }
  },
  methods: {
    async login() {
      const headers = {
        "Content-Type": "application/json"
      };
      const object = {
        user: "cta_web",
        password: "W9C*#C7rx.S4"
      };
      try {
        const resp = await axios.post(
          config.CTAURL+"/auth/login",
          object,
          headers
        );
        this.loggedData = resp.data;
        //this.loading = false;
        return true;
      } catch (error) {
        this.loading = false;
        console.log(error);
        return false;
      }
    },
    async getRankings(modality, limit, skip) {
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${this.loggedData.access_token}`
      };

      const object = {
        modality: modality,
        limit: limit,
        skip: skip
      };
      try {
        this.loading = true;
        const resp = await axios.post(
           config.CTAURL+"/ranking",
          object,
          { headers: headers }
        );
        this.totalItems = resp.data.total;
        this.rankings = resp.data.players.map(item => {
          return {
            name: item.name,
            club: item.club,
            ranking: item.ranking
          };
        });
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
        return false;
      }
    },
    async getModalities() {
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${this.loggedData.access_token}`
      };
      try {
        const response = await axios.get(
           config.CTAURL+"/modalities ",
          { headers: headers }
        );
        this.options = response.data.modalities.map(item => {
          return {
            value: item.name,
            text: item.name
          };
        });
        return true;
      } catch (error) {
        console.log(error);
        return false;
      }
    }
  },
  async mounted() {
    this.modalidad = this.$route.params.id;
    this.loading = true;
    this.login();
    this.loading = true;
    await this.login();
    await this.getModalities();
    await this.getRankings(this.modalidad, this.perPage, this.currentPage);
  }
};
</script>
